module.exports = __webpack_public_path__ + "travel_vintage-travel_1.jpg";